import { Action } from "../../../../types/state/action";
import {
  IColor,
  IDecorationTech,
  ILicensedProperty,
  ILicensor,
  IMold,
} from "../../../../types/data.interface";
import { CreateArtworkCollectionState } from "../collection/create/data";
import { CreatePrintingTechniqueState } from "../printingTechnique/create/data";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

interface IFilters{
  limit: number;
  lastDays: number;
  requestor: string;
  status: string[];
  search: string;
  hasFilterApplied: boolean;
  offset: number;
}

interface ISearchFilters{
  limit: number;
  search: string;
  offset: number;
  requesting_market: {
    full_name: string;
    id: string;
    short_name: string;
  };
}

interface ICollectionSearchFilters extends ISearchFilters {
  collection: ValueOrNull<CreateArtworkCollectionState>;
  licensor: ValueOrNull<ILicensor>;
  licensed_property: ValueOrNull<ILicensedProperty>;
  launch_date: string;
  year:any
}

interface IPrintingTechniqueSearchFilters extends ISearchFilters {
  printingTechnique: ValueOrNull<CreatePrintingTechniqueState>;
  name: ValueOrNull<string>
  code: ValueOrNull<string>
  molds: ValueOrNull<IMold[]>
  decoration_technique: ValueOrNull<IDecorationTech>;
  color: ValueOrNull<IColor>;
  collection:  ValueOrNull<CreateArtworkCollectionState>;

}

export type ArtworkApprovalsState = {
  collectionFilters: IFilters;
  collectionSearchFilters: ICollectionSearchFilters;
  collectionResults: any;
  collectionSearchResults: any;
  collectionApprovalResultsIsLoading:boolean;
  collectionSearchResultsIsLoading:boolean;
  printingTechniqueResults:any;
  printingTechniqueFilters: IFilters;
  printingTechniqueSearchFilters: IPrintingTechniqueSearchFilters;
  printingTechniqueSearchResults:any;
  printingTechniqueSearchResultsIsLoading:boolean;
  printingTechniqueApprovalResultsIsLoading:boolean;
};

export enum ArtworkApprovalRequestTypes {
  SET_LIMIT = "limit",
  SET_LAST_DAYS = "lastDays",
  SET_REQUESTOR = "requestor",
  SET_STATUS = "status",
  SET_SEARCH = "search",
  SET_FILTER_APPLIED = "hasFilterApplied",
  SET_OFFSET = "offset",
  SET_DATA_RESULTS = "dataResults",
  SET_APPROVAL_STATE = "setApprovalState",
  SET_COLLECTION_RESULTS = "collectionResults",
  SET_COLLECTION_SEARCH_RESULTS = "collectionSearchResults",
  SET_PRINTING_TECHNIQUE_RESULTS = "printingTechniqueResults",
  SET_PRINTING_TECHNIQUE_SEARCH_RESULTS = "printingTechniqueSearchResults",
  SET_PRINTING_TECHNIQUE_FILTERS = "printingTechniqueFilters",
  SET_PRINTING_TECHNIQUE_SEARCH_FILTERS = "printingTechniqueSearchFilters",
  SET_COLLECTION_FILTERS = "collectionFilters",
  SET_COLLECTION_SEARCH_FILTERS = "collectionSearchFilters",
  SET_PRINTING_TECHNIQUE_SEARCH_IS_LOADING = 'printingTechniqueSearchResultsIsLoading',
  SET_PRINTING_TECHNIQUE_APPROVAL_IS_LOADING = 'printingTechniqueApprovalResultsIsLoading',
  SET_COLLECTION_SEARCH_IS_LOADING = 'collectionSearchResultsIsLoading',
}

export type ArtworkApprovalRequestType = Action<
  ArtworkApprovalRequestTypes,
  Partial<ArtworkApprovalsState>
>;
